import { RouteRecordRaw } from 'vue-router';
import customerRoutes from './customerRoutes';
import onboardingRoutes from './onboardingRoutes';
import profileRoutes from './profileRoutes';
import publicRoutes from './publicRoutes';
import schedulerRoutes from './schedulerRoutes';
import servicesRoutes from './servicesRoutes';

const routes: RouteRecordRaw[] = [
	...publicRoutes,
	...customerRoutes,
	...onboardingRoutes,
	...profileRoutes,
	...servicesRoutes,
	...schedulerRoutes,
];

export default routes;
